import { app } from '../../../app';

app.factory('SlackInfoService', SlackInfoService);

/** @ngInject */
function SlackInfoService($resource) {
    var getSlackAuthorizeUrl = $resource('app/rest/slack/getauthurl/:companyId', {
        companyId : '@companyId',
    }, {});
    var processSlackAuth = $resource('app/rest/slack/processauth/:companyId', {
        companyId : '@companyId',
    }, {});    
    return {
        getSlackAuthorizeUrl : getSlackAuthorizeUrl,
        processSlackAuth : processSlackAuth
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/slack-info/slack-info.service.js